import { baseURL } from '../Config';
import axios from 'axios';
import { toast } from 'react-toastify';

export const handleGetRequest = async (url, isShowToast = false, responseCode = '') => {
    try {
        const token = localStorage.getItem('token');
        const headers = {};
        if (token) {
            headers['Authorization'] = token; // raw token (backend may expect raw)
            headers['token'] = token;
            headers['x-access-token'] = token;
            try {
                // eslint-disable-next-line no-console
                console.debug('[GetTemplate] using token for request to', url, token ? `${token.substring(0, 12)}...` : 'NO_TOKEN');
            } catch (e) {}
        }

        const response = await axios.get(`${baseURL + url}`, { headers });
        if (isShowToast && (responseCode === '' || responseCode === response?.data?.responseCode)) {
            toast.success(response?.data?.messages || response?.data?.message);
        } else if (isShowToast) {
            toast.error(response?.data?.messages || response?.data?.message);
        }
        return response.data;
    } catch (error) {
        // If unauthorized, force re-login
        if (error?.response?.status === 401 || error?.response?.data?.message === 'Invalid Token' || error?.response?.data?.message === 'Session Expired') {
            try {
                localStorage.removeItem('token');
                localStorage.removeItem('userId');
            } catch (e) {}
            try {
                localStorage.clear();
            } catch (e) {}
            try {
                toast.warn('Session expired. Redirecting to login...');
            } catch (e) {}
            setTimeout(() => {
                window.location.href = '/';
            }, 1000);
            return error?.response;
        }

        const id = toast.loading('Please wait...');
        if (error?.response?.status === 500) {
            setTimeout(() => {
                toast.update(id, {
                    render: error?.response?.data?.message || error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong !!',
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000
                });
            }, 100);
        } else {
            setTimeout(() => {
                toast.update(id, {
                    render: error?.response?.data?.message || error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong !!',
                    type: 'warn',
                    isLoading: false,
                    autoClose: 3000
                });
            }, 100);
        }
    }
};
